import { DataGrid } from '@mui/x-data-grid'
import { getArvColumns } from './columns'

export default function ComparableGrid({ rows, onRowClick, onToggleArchived, onGalleryOpen }) {
  const columns = getArvColumns({ onRowClick, onToggleArchived, onGalleryOpen })

  return (
    <div className=" rounded-lg overflow-hidden">
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.propertyId}
      rowHeight={72}
      autoHeight
      hideFooter
      disableRowSelectionOnClick
      sx={{
        border: 'none',
        fontFamily: 'Figtree',
        overflow: 'hidden',
        '--DataGrid-rowBorderColor': '#DAE4D5',
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#E7F0E2',
          borderBottom: 'none',
          minHeight: '52px !important',
          maxHeight: '52px !important',
          padding:'0 0'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          padding:'0 0',
          fontSize: 14,
          fontWeight: 700,
          color: '#17270D',
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          alignItems: 'center',
          padding: '0 0',
        },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: '#E8F5E1',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
          padding: '0 !important', 
        }
      }}
    />
    </div>
  )
}
